// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Center } from '@/components/ui/layout';
import { Title, Text, Button, Anchor } from '@/components/ui/core';
import { TextInput } from '@/components/ui/inputs';
import { IconMail, IconArrowLeft, IconKey } from '@tabler/icons-react';
import { AuthLayoutWrapper } from '../components';

export default function ForgotHeroImage() {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Reset password for:', email);
  };

  return (
    <AuthLayoutWrapper
      variant="cover"
      backgroundImage="https://images.unsplash.com/photo-1614850523459-c2f4c699c52e?w=1920&q=80"
    >
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/demo/auth-pages/forgot-password"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Header */}
        <Center>
          <Stack align="center" gap="xs">
            <Center
              style={{
                width: 56,
                height: 56,
                borderRadius: 14,
                background: 'linear-gradient(135deg, #f97316, #dc2626)',
              }}
            >
              <IconKey size={28} color="white" />
            </Center>
            <Title order={2} ta="center">Forgot password?</Title>
            <Text c="dimmed" size="sm" ta="center">
              We'll email you a reset link
            </Text>
          </Stack>
        </Center>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <TextInput
              label="Email"
              placeholder="your@email.com"
              leftSection={<IconMail size={16} />}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <Button
              type="submit"
              fullWidth
              variant="gradient"
              gradient={{ from: 'orange', to: 'red' }}
            >
              Send reset link
            </Button>
          </Stack>
        </form>

        {/* Back to Login */}
        <Center>
          <Anchor component={Link} to="/demo/auth-pages/login/cover" size="sm">
            <IconArrowLeft size={14} style={{ marginRight: 4, verticalAlign: 'middle' }} />
            Back to login
          </Anchor>
        </Center>
      </Stack>
    </AuthLayoutWrapper>
  );
}
